import React from 'react'

import style from './Introduce.module.scss'

const Introduce = () => {
	return (
		<section className={style.introduce}>
			<div className={style.wrapper}>
				<h1 className={style.heading}>Giới thiệu</h1>
				<p className={style.desc}>
					Nếu bạn đang tìm kiếm một trang web để mua và bán hàng trực tuyến thì
					MCart là một sự lựa chọn tuyệt vời dành cho bạn. MCart là trang thương
					mại điện tử cho phép người mua và người bán tương tác và trao đổi dễ
					dàng thông tin về sản phẩm và chương trình khuyến mãi của shop. Do đó,
					việc mua bán trên MCart trở nên nhanh chóng và đơn giản hơn. Bạn có
					thể trò chuyện trực tiếp với nhà bán hàng để hỏi trực tiếp về mặt hàng
					cần mua. Để bạn có thể dễ dàng khi tìm hiểu và sử dụng sản phẩm, MCart
					Blog - trang blog thông tin chính thức của MCart - sẽ giúp bạn có thể
					tìm được cho mình các kiến thức về xu hướng thời trang, review công
					nghệ, mẹo làm đẹp, tin tức tiêu dùng và deal giá tốt bất ngờ. Đến với
					MCart, cơ hội để trở thành một nhà bán hàng dễ dàng hơn bao giờ hết.
					Chỉ với vài thao tác trên ứng dụng, bạn đã có thể đăng bán ngay những
					sản phẩm của mình. Không những thế, các nhà bán hàng có thể tự tạo
					chương trình khuyến mãi trên MCart để thu hút người mua với những sản
					phẩm có mức giá hấp dẫn. Khi đăng nhập tại ND Mall Kênh người bán, bạn
					có thể dễ dàng phân loại sản phẩm, theo dõi đơn hàng, chăm sóc khách
					hàng và cập nhập ngay các hoạt động của shop.
				</p>
			</div>
		</section>
	)
}

export default Introduce
